import { BannerCTA } from "../../models/BannerCTA";

const $ = window.$;

export function BannerHeader({
  element,
  parent,
  banner = new BannerCTA(),
  hasAnimation = false,
  section = ""
}) {
  console.log({ banner, element, parent, hasAnimation, section });
  if (banner.type === "image" && banner.image) {
    let $img = $('<img>').attr('src', banner.image).attr('class', "sales-banner").css('display', 'none');
    $img.on('load', (e) => {
      $(".sales-banner", element).css("display", "block");
      if (hasAnimation) {
        setTimeout(() => {
          $(".sales-banner", element).addClass("active");
        }, 100);
      }
    });
    element.append($img);
    section ? section.removeClass("hide") : parent.removeClass("hide");
    if (hasAnimation) {
      element.addClass("animation");
    }
  }

  element.on("click", (e) => {
    let url = banner.getRedirectURL();
    if (url) {
      window.location.href = url;
    }
  })
}